import { Injectable } from '@angular/core'
import { BaseService } from '@appService/base.service'
import { Observable } from 'rxjs'
import { ResponseModel } from '../api-response.model'

@Injectable({
  providedIn: 'root'
})
export class CategoryAcademicYearsService extends BaseService {
  contextPath = '/api/academic-years'

  apiSearch(payload: any): Observable<ResponseModel<any[]>> {
    return this.get(`${this.contextPath}`, payload)
  }

  createAcademic(payload: any): Observable<ResponseModel<any[]>> {
    return this.post(`${this.contextPath}`, payload)
  }

  detailAcademic(payload: any): Observable<ResponseModel<any[]>> {
    return this.get(`${this.contextPath}/${payload?.id}`, payload)
  }

  updateAcademic(payload: any, id: any): Observable<ResponseModel<any[]>> {
    return this.put(`${this.contextPath}/${id}`, payload)
  }

  deleteAcademic(id: any): Observable<ResponseModel<any[]>> {
    return this.delete(`${this.contextPath}/${id}`)
  }

  getDropdown(payload: any): Observable<any> {
    return this.get(`${this.contextPath}/list`, payload)
  }

  updatePlayerByYear(payload: any): Observable<any> {
    return this.put(`${this.contextPath}/${payload?.id}/player`, payload?.classList)
  }
}
